/**
 * Created by coolguy on 2017/4/15.
 * copy from 倍棒小店项目
 */
import * as R from 'ramda';
import request from 'utils/request';
import { useEffect, useState } from 'react';

import url from './url';

let headers = {
  //反正就目前只有这个一个情况
  json: {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  },
  jsonv2: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=UTF-8',
  },
};

//  @ts-ignore
const ajax = (opts, defaultHandleError = false) => {
  opts = Object.assign(
    {},
    {
      method: 'get',
      type: 'json',
      headers: headers['json'],
      credentials: 'include', //不能设置成Include，会出错，要求服务器必须得设置CORS且不能是*
    },
    opts
  );
  !opts.method && (opts.method = 'get');
  opts.method = opts.method.toLowerCase();
  opts.body = opts.data || opts.body;
  delete opts.data;

  var theUrl = url(opts.url);
  if (typeof opts.body != 'undefined') {
    if (opts.method === 'get') {
      var target = theUrl.mergeParams(opts.body || {});
      opts.url = target.toString();
      opts.body = undefined;
      delete opts.body;
    } else {
      //body请注意，不支持多级嵌套型的数据格式，如果有请再考虑
      opts.body =
        typeof opts.body == 'string' ? opts.body : theUrl.serialize(opts.body);
    }
  }
  opts.headers = Object.assign({}, opts.headers, headers[opts.type]);
  return fetch(opts.url, opts)
    .then(function (response) {
      if (!response.ok) {
        //考虑到404等压根就不会按照正常的JSON格式数据给出来
        if (response.status === 401) {
          console.error(401, response);
          // 401 的时候是否弹出全局框还说直接跳转回首页
          //var current_page = url(location.href);
          //var param = current_page.query;
          // window.location.href =
          //   config.api +
          //   '/gallery?id=' +
          //   param.id +
          //   (param.test ? '&test=1' : '');
          return;
        }
        return response.text().then((text) => {
          let json;
          try {
            json = JSON.parse(text);
          } catch (e) {
            json = {
              detail: text,
            };
          }
          var error = new Error();
          error.name = response.status;
          console.log('---error happened---');
          console.log('http status', error.name);
          error.data = json;
          //catch依赖于这里throw，请自行留意
          throw error;
        });
      }
      return response.json().then(function (json) {
        return json;
      });
    })
    .catch((e) => {
      if (defaultHandleError) {
        if (e && e.data) {
          let { error } = e.data;
        }
      }
      console.warn(e);
      //一定要继续抛出去，否则会被认定异常处理完成，进入成功的then了
      throw e;
    });
};

export default ajax;

export const post = (url, data = {}) => {
  return request({
    url,
    method: 'POST',
    type: 'jsonv2',
    credentials: 'include',
    data: JSON.stringify(data),
    headers: {
      Authorization: request.token,
    },
  });
};

export const get = (url, params = {}) => {
  return request({
    url,
    method: 'GET',
    type: 'jsonv2',
    credentials: 'include',
    data: params,
    headers: {
      Authorization: request.token,
    },
  });
};

export const useMethod = ({
  url,
  paramsOrData = {},
  method = 'get',
  setData = R.T,
  deps=[],
} = {}) => {
  const [loading, setLoading] = useState(true);
  const [resData, setResData] = useState(undefined);
  const [error, setError] = useState(null);
  useEffect(() => {
    setLoading(true);

    (method.toLowerCase() === 'get' ? get : post)(url, paramsOrData)
      .then((res) => {
        setData(res);
        setResData(res);
      })
      .catch(setError)
      .finally(() => {
        setLoading(false);
      });
  }, [url, JSON.stringify(paramsOrData), JSON.stringify(deps)]);
  return { data: resData, loading, error };
};

export const useGet = (url, params = {}, options = {}) => {
  const { setData = R.T, deps = [] } = options;
  return useMethod({
    url,
    paramsOrData: params,
    method: 'get',
    setData,
    deps,
  });
};

export const usePost = (url, data = {}, setData = R.T) => {
  return useMethod({
    url,
    paramsOrData: data,
    method: 'post',
    setData,
  });
};
